<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M 14 5 c 0 0.133 -0.055 0.258 -0.148 0.352 l -4 4 c -0.094 0.094 -0.219 0.148 -0.352 0.148 c -0.273 0 -0.5 -0.227 -0.5 -0.5 v -2 h -1.75 c -3.367 0 -5.578 0.648 -5.578 4.375 c 0 0.32 0.016 0.641 0.039 0.961 c 0.008 0.125 0.039 0.266 0.039 0.391 c 0 0.148 -0.094 0.273 -0.25 0.273 c -0.109 0 -0.164 -0.055 -0.219 -0.133 c -0.117 -0.164 -0.203 -0.414 -0.289 -0.594 c -0.445 -1 -0.992 -2.43 -0.992 -3.523 c 0 -0.875 0.086 -1.773 0.414 -2.602 c 1.086 -2.695 4.273 -3.148 6.836 -3.148 h 1.75 v -2 c 0 -0.273 0.227 -0.5 0.5 -0.5 c 0.133 0 0.258 0.055 0.352 0.148 l 4 4 c 0.094 0.094 0.148 0.219 0.148 0.352 Z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-mail-forward.html